import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import { createSubheaderRow, createMultiFoodRows } from '../../util/util';
import MultiFoodResultTable from './MultiFoodResultTable';

const createCsvHeader = foods => {
  const csvHeader = [
    {label: 'Category', key: 'category'},
    {label: 'Nutrient', key: 'nutrient'},
    {label: 'Unit', key: 'unit'},
  ];
  foods.forEach((food, i) => {
    csvHeader.push({
      label: food.shortname, key: `food${i + 1}`
    });
  });
  return csvHeader;
};

class MultiFoodBasic extends Component {
  constructor(props) {
    super(props);
    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  componentDidMount() {
    const csvHeader = createCsvHeader(this.props.selectedFoods);
    this.props.setCsvHeader(csvHeader);
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.selectedFoods !== nextProps.selectedFoods) {
      const csvHeader = createCsvHeader(nextProps.selectedFoods);
      this.props.setCsvHeader(csvHeader);
    }
  }

  render() {
    const {
      unitFetch,
      proximatesComponentSetFetch,
      fatsComponentSetFetch,
      carbohydratesComponentSetFetch,
      vitaminsComponentSetFetch,
      mineralsComponentSetFetch,
      food1FullFetch, food2FullFetch, food3FullFetch,
    } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([
          unitFetch,
          proximatesComponentSetFetch,
          fatsComponentSetFetch,
          carbohydratesComponentSetFetch,
          vitaminsComponentSetFetch,
          mineralsComponentSetFetch,
          food1FullFetch, food2FullFetch, food3FullFetch,
        ].filter(n => n))}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([units,
    proximatesComponentSet,
    fatsComponentSet,
    carbohydratesComponentSet,
    vitaminsComponentSet,
    mineralsComponentSet,
    ...foodFulls
  ]) {
    // combine full of each food to food objects
    const { selectedFoods, selectedReport, per100g } = this.props;
    selectedFoods.forEach((food, i) => {
      food.components = foodFulls[i];
    });

    const tableData = createSubheaderRow('Proximates')
      .concat(createMultiFoodRows(proximatesComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Fats'))
      .concat(createMultiFoodRows(fatsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Carbohydrates'))
      .concat(createMultiFoodRows(carbohydratesComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Vitamins'))
      .concat(createMultiFoodRows(vitaminsComponentSet.components, selectedFoods, units, per100g))
      .concat(createSubheaderRow('Minerals'))
      .concat(createMultiFoodRows(mineralsComponentSet.components, selectedFoods, units, per100g));

    return (
      <div className="MultiFoodResult">

        <MultiFoodResultTable
          tableType='basic'
          tableData={tableData}
          selectedFoods={selectedFoods}
          selectedReport={selectedReport}
          setCsvData={this.props.setCsvData}
          per100g = {per100g}
        />

      </div>
    );
  }
}

MultiFoodBasic.propTypes = {
  unitFetch: PropTypes.instanceOf(PromiseState),
  proximatesComponentSetFetch: PropTypes.instanceOf(PromiseState),
  fatsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  carbohydratesComponentSetFetch: PropTypes.instanceOf(PromiseState),
  vitaminsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  mineralsComponentSetFetch: PropTypes.instanceOf(PromiseState),
  food1FullFetch: PropTypes.instanceOf(PromiseState),
  food2FullFetch: PropTypes.instanceOf(PromiseState),
  food3FullFetch: PropTypes.instanceOf(PromiseState),
  selectedFoods: PropTypes.array,
  selectedReport: PropTypes.string,
  per100g: PropTypes.bool.isRequired,
  setCsvHeader: PropTypes.func.isRequired,
  setCsvData: PropTypes.func.isRequired,
};

const fetch = props => {
  if (!props.selectedFoods) { return null; } // don't fetch
  let fetchObject = {
    unitFetch: `${BASE_URL}/unit`,
    proximatesComponentSetFetch: `${BASE_URL}/component/set/6`,
    fatsComponentSetFetch: `${BASE_URL}/component/set/7`,
    carbohydratesComponentSetFetch: `${BASE_URL}/component/set/8`,
    vitaminsComponentSetFetch: `${BASE_URL}/component/set/9`,
    mineralsComponentSetFetch: `${BASE_URL}/component/set/10`,
  };
  props.selectedFoods.forEach((food, i) => {
    const query = food.serving_size_value ? `?amount=${food.serving_size_value}&` : '?';
    fetchObject[`food${i + 1}FullFetch`] = `${BASE_URL}/fiav/food/${food.recordid}${query}comp_group_id=12`;
  });
  return fetchObject;
};

export default connect(fetch)(MultiFoodBasic);



// WEBPACK FOOTER //
// ./src/components/search/multiFood/MultiFoodBasic.js